"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _GEHelper = require("../graphicEngine/GEHelper");
var _audioUtils = _interopRequireDefault(require("../util/audioUtils"));
var EntryEngineState = {
  stop: 'stop',
  stopping: 'stopping',
  pause: 'pause',
  run: 'run'
};
Entry.Engine = /*#__PURE__*/function () {
  function Engine() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, Engine);
    /**
     * 매 틱당 실행되며, canvas, object 를 업데이트한다.
     * 추가로, 하드웨어의 데이터도 업데이트한다.
     */
    (0, _defineProperty2["default"])(this, "update", function () {
      if (Entry.engine.isState('run')) {
        if (Entry.wasmEngine && Entry.wasmEngine.isActive()) {
          return;
        }
        Entry.container.mapObjectOnScene(_this.computeFunction);
        if (Entry.hw.communicationType !== 'manual') {
          Entry.hw.update();
        }
        _this._processEngineTimeouts();
      }
    });
    /**
     * this is callback function for map.
     * @param {Entry.EntryObject} object
     * @param {string} eventName
     */
    (0, _defineProperty2["default"])(this, "raiseEvent", function (entity, eventName) {
      entity.parent.script.raiseEvent(eventName, entity);
    });
    this.execPromises = [];
    this.state = EntryEngineState.stop;
    this.popup = null;
    this.isUpdating = true;
    this.speeds = [1, 15, 30, 45, 60];
    this.engineTimer = {
      isInit: false,
      isPaused: false,
      start: 0,
      pauseStart: 0,
      pausedTime: 0
    };
    this._engineTimeouts = [];
    this._engineTimeoutSeq = 0;
    this.attachKeyboardCapture();
    var _addEventListener = Entry.addEventListener.bind(Entry);
    _addEventListener('canvasClick', function () {
      return _this.fireEvent('mouse_clicked');
    });
    _addEventListener('canvasClickCanceled', function () {
      return _this.fireEvent('mouse_click_cancled');
    });
    _addEventListener('entityClick', function (entity) {
      var objId = entity.id;
      Entry.stage.clickedObjectId = objId;
      _this.fireEventOnEntity('when_object_click', entity);
    });
    _addEventListener('entityClickCanceled', function (entity) {
      delete Entry.stage.clickedObjectId;
      _this.fireEventOnEntity('when_object_click_canceled', entity);
    });
    if (Entry.type !== 'phone' && Entry.type !== 'playground') {
      _addEventListener('stageMouseMove', _.throttle(this.updateMouseView.bind(this), 100, {
        leading: false
      }));
      _addEventListener('stageMouseOut', this.hideMouseView.bind(this));
    }
    var $win = $(window);
    _addEventListener('run', function () {
      return $win.bind('keydown', arrowHandler);
    });
    _addEventListener('stop', function () {
      return $win.unbind('keydown', arrowHandler);
    });
    function arrowHandler(e) {
      var code = e.keyCode || e.which;
      var input = Entry.stage.inputField;
      if (code === 32 && input && input.hasFocus()) {
        return;
      }
      if (_.includes([37, 38, 39, 40, 32], code)) {
        e.preventDefault();
      }
    }
    Entry.message = new Entry.Event(window);
  }

  /**
   * Control bar view generator.
   * @param {!Element} controlView controlView from Entry.
   * @param {?string} option for choose type of view.
   */
  return (0, _createClass2["default"])(Engine, [{
    key: "generateView",
    value: function generateView(controlView) {
      var _this2 = this;
      var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'workspace';
      this.option = option;
      if (option === 'workspace') {
        /** @type {!Element} */
        this.view_ = controlView;
        this.view_.addClass('entryEngine_w').addClass('entryEngineWorkspace_w');
        this.view_.addClass('test');
        this.speedButton = Entry.createElement('button').addClass('entrySpeedButtonWorkspace', 'entryEngineTopWorkspace', 'entryEngineButtonWorkspace_w').appendTo(this.view_).bindOnClick(function (e) {
          Entry.engine.toggleSpeedPanel();
          this.blur();
        });
        this.maximizeButton = Entry.createElement('button').addClass('entryEngineButtonWorkspace_w', 'entryEngineTopWorkspace', 'entryMaximizeButtonWorkspace_w').appendTo(this.view_).bindOnClick(function (e) {
          Entry.engine.toggleFullScreen();
          this.blur();
        });
        this.coordinateButton = Entry.createElement('button').addClass('entryEngineButtonWorkspace_w', 'entryEngineTopWorkspace', 'entryCoordinateButtonWorkspace_w').appendTo(this.view_).bindOnClick(function (e) {
          if (this.hasClass('toggleOn')) {
            this.removeClass('toggleOn');
          } else {
            this.addClass('toggleOn');
          }
          this.blur();
          Entry.stage.toggleCoordinator();
        });
        this.mouseView = Entry.createElement('div').addClass('entryMouseViewWorkspace_w').addClass('entryHide').appendTo(this.view_);
        this.mouseViewInput = Entry.createElement('input').appendTo(this.mouseView);
        $(this.mouseViewInput).attr('readonly', 'readonly');
        this.buttonWrapper = Entry.createElement('div').addClass('entryEngineButtonWrapper');
        this.view_.after(this.buttonWrapper);

        /*
          TODO markup
          오브젝트 추가하기, 시작하기, 미사용버튼, 기본 일시정지/다시시작,
          전체화면 일시정지/다시시작, 기본/전체화면 정지 순서
         */
        this.addButton = Entry.createElement('button').addClass('entryEngineButtonWorkspace_w').addClass('entryAddButtonWorkspace_w').bindOnClick(function () {
          Entry["do"]('addObjectButtonClick');
          this.blur();
        }).appendTo(this.buttonWrapper);
        this.addButton.textContent = Lang.Workspace.add_object;
        if (!Entry.objectAddable) {
          this.addButton.addClass('entryRemove');
        }
        this.runButton = Entry.createElement('button').addClass('entryEngineButtonWorkspace_w').addClass('entryRunButtonWorkspace_w').bindOnClick(function () {
          return Entry["do"]('toggleRun', 'runButton');
        }).appendTo(this.buttonWrapper);
        this.runButton.textContent = Lang.Workspace.run;
        this.runButton2 = Entry.createElement('button').addClass('entryEngineButtonWorkspace_w').addClass('entryRunButtonWorkspace_w2').appendTo(this.buttonWrapper).bindOnClick(function () {
          return Entry.engine.toggleRun();
        });
        this.pauseButton = Entry.createElement('button').addClass('entryEngineButtonWorkspace_w').addClass('entryPauseButtonWorkspace_w').addClass('entryRemove').appendTo(this.buttonWrapper).bindOnClick(function (e) {
          this.blur();
          Entry.engine.togglePause();
        });
        this.pauseButtonFull = Entry.createElement('button').addClass('entryEngineButtonWorkspace_w').addClass('entryPauseButtonWorkspace_full').addClass('entryRemove').appendTo(this.buttonWrapper).bindOnClick(function () {
          this.blur();
          Entry.engine.togglePause();
        });
        this.stopButton = Entry.createElement('button').addClass('entryEngineButtonWorkspace_w').addClass('entryStopButtonWorkspace_w').addClass('entryRemove').bindOnClick(function () {
          return Entry["do"]('toggleStop', 'stopButton');
        }).appendTo(this.buttonWrapper);
        this.stopButton.textContent = Lang.Workspace.stop;
        this.stopButton2 = Entry.createElement('button').addClass('entryEngineButtonWorkspace_w').addClass('entryStopButtonWorkspace_w2').addClass('entryRemove').bindOnClick(function () {
          this.blur();
          Entry.engine.toggleStop();
        }).appendTo(this.buttonWrapper);
        this.stopButton2.textContent = Lang.Workspace.stop;
      } else if (option == 'minimize') {
        /** @type {!Element} */
        this.view_ = controlView;
        this.view_.addClass('entryEngine');
        this.view_.addClass('entryEngineMinimize');
        this.maximizeButton = Entry.createElement('button');
        this.maximizeButton.addClass('entryEngineButtonMinimize');
        this.maximizeButton.addClass('entryMaximizeButtonMinimize');
        this.view_.appendChild(this.maximizeButton);
        this.maximizeButton.bindOnClick(function (e) {
          Entry.engine.toggleFullScreen();
        });
        this.coordinateButton = Entry.createElement('button');
        this.coordinateButton.addClass('entryEngineButtonMinimize');
        this.coordinateButton.addClass('entryCoordinateButtonMinimize');
        this.view_.appendChild(this.coordinateButton);
        this.coordinateButton.bindOnClick(function (e) {
          if (this.hasClass('toggleOn')) {
            this.removeClass('toggleOn');
          } else {
            this.addClass('toggleOn');
          }
          Entry.stage.toggleCoordinator();
        });
        this.stopButton = Entry.createElement('button');
        this.stopButton.addClass('entryEngineButtonMinimize');
        this.stopButton.addClass('entryStopButtonMinimize');
        this.stopButton.addClass('entryRemove');
        this.stopButton.textContent = Lang.Workspace.stop;
        this.view_.appendChild(this.stopButton);
        this.stopButton.bindOnClick(function (e) {
          this.blur();
          Entry.engine.toggleStop();
        });
        this.pauseButton = Entry.createElement('button');
        this.pauseButton.textContent = Lang.Workspace.pause;
        this.pauseButton.addClass('entryEngineButtonMinimize');
        this.pauseButton.addClass('entryPauseButtonMinimize');
        this.pauseButton.addClass('entryRemove');
        this.view_.appendChild(this.pauseButton);
        this.pauseButton.bindOnClick(function (e) {
          this.blur();
          Entry.engine.togglePause();
        });
        this.mouseView = Entry.createElement('div');
        this.mouseView.addClass('entryMouseViewMinimize');
        this.mouseView.addClass('entryHide');
        this.mouseViewInput = Entry.createElement('input').appendTo(this.mouseView);
        $(this.mouseViewInput).attr('readonly', 'readonly');
        $(this.mouseViewInput).attr('style', 'border: none;-webkit-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;line-height: normal');
        this.view_.appendChild(this.mouseView);
        var setRunButton = function setRunButton(isLoaded) {
          if (!isLoaded) {
            return;
          }
          _this2.isLoaded = true;
          var isSoundEmpty = Entry.soundQueue.urls.size < 1;
          if (isSoundEmpty || Entry.soundQueue.loadComplete) {
            if (!_this2.runButtonCurtain) {
              _this2.runButtonCurtain = Entry.Dom('div', {
                "class": 'entryRunButtonBigMinimizeCurtain',
                parent: $('#entryCanvasWrapper')
              });
            }
            if (!_this2.runButton) {
              _this2.runButton = Entry.Dom('div', {
                "class": 'entryRunButtonBigMinimize',
                parent: _this2.runButtonCurtain
              });
              _this2.runButton.bindOnClick(function () {
                return Entry.engine.toggleRun();
              });
            }
            if (Entry.options.isStartOnLoaded && Entry.engine.state === 'stop') {
              Entry.engine.toggleRun();
            }
          }
        };
        Entry.addEventListener('loadComplete', function () {
          return setRunButton(true);
        });
        Entry.addEventListener('soundLoaded', function () {
          return setRunButton(_this2.isLoaded);
        });
      } else if (option == 'phone') {
        this.view_ = controlView;
        this.view_.addClass('entryEngine', 'entryEnginePhone');
        this.headerView_ = Entry.createElement('div', 'entryEngineHeader');
        this.headerView_.addClass('entryEngineHeaderPhone');
        this.view_.appendChild(this.headerView_);
        this.maximizeButton = Entry.createElement('button');
        this.maximizeButton.addClass('entryEngineButtonPhone', 'entryMaximizeButtonPhone');
        this.headerView_.appendChild(this.maximizeButton);
        this.maximizeButton.bindOnClick(function (e) {
          Entry.engine.footerView_.addClass('entryRemove');
          Entry.engine.headerView_.addClass('entryRemove');
          Entry.launchFullScreen(Entry.engine.view_);
        });
        document.addEventListener('fullscreenchange', function (e) {
          Entry.engine.exitFullScreen();
        });
        document.addEventListener('webkitfullscreenchange', function (e) {
          Entry.engine.exitFullScreen();
        });
        document.addEventListener('mozfullscreenchange', function (e) {
          Entry.engine.exitFullScreen();
        });
        this.footerView_ = Entry.createElement('div', 'entryEngineFooter');
        this.footerView_.addClass('entryEngineFooterPhone');
        this.view_.appendChild(this.footerView_);
        this.runButton = Entry.createElement('button');
        this.runButton.addClass('entryEngineButtonPhone', 'entryRunButtonPhone');
        if (Entry.objectAddable) {
          this.runButton.addClass('small');
        }
        this.runButton.textContent = Lang.Workspace.run;
        this.footerView_.appendChild(this.runButton);
        this.runButton.bindOnClick(function (e) {
          Entry.engine.toggleRun();
        });
        this.stopButton = Entry.createElement('button');
        this.stopButton.addClass('entryEngineButtonPhone', 'entryStopButtonPhone', 'entryRemove');
        if (Entry.objectAddable) {
          this.stopButton.addClass('small');
        }
        this.stopButton.textContent = Lang.Workspace.stop;
        this.footerView_.appendChild(this.stopButton);
        this.stopButton.bindOnClick(function (e) {
          Entry.engine.toggleStop();
        });
      }
    }
  }, {
    key: "toggleAudioShadePanel",
    value: function toggleAudioShadePanel() {
      if (this.audioShadePanelOn) {
        this.audioShadePanelOn = false;
        $(this.audioShadePanel_).remove();
        delete this.audioShadePanel_;
      } else if (Entry.engine.isState('run')) {
        this.audioShadePanelOn = true;
        this.audioShadePanel_ = Entry.createElement('div', 'audioShadeCirclebox');
        this.audioShadePanel_.addClass('audioShadeCirclebox');
        var audioShadeMainCircle = Entry.createElement('div', 'audioShadeCircle').addClass('audioShadeCircle');
        audioShadeMainCircle.appendChild(Entry.createElement('div', 'audioShadeInner').addClass('audioShadeInner'));
        audioShadeMainCircle.appendChild(Entry.createElement('div', 'audioShadeInner').addClass('audioShadeInner'));
        audioShadeMainCircle.appendChild(Entry.createElement('div', 'audioShadeInner').addClass('audioShadeInner'));
        this.audioShadePanel_.appendChild(audioShadeMainCircle);
        var micImage = Entry.createElement('img', 'audioShadeImg').addClass('audioShadeImg');
        micImage.src = "".concat(Entry.mediaFilePath, "ic-audio-sensing-mic.svg");
        audioShadeMainCircle.appendChild(micImage);
        var audioShadeText = Entry.createElement('div', 'audioShadeText').addClass('audioShadeText');
        audioShadeText.textContent = Lang.Msgs.ai_utilize_audio_listening;
        this.audioShadePanel_.appendChild(audioShadeText);
        this.minimizedView_ = document.querySelector('#entryCanvasWrapper');
        if (this.view_.classList[0] === 'entryEngine') {
          this.minimizedView_.insertBefore(this.audioShadePanel_, Entry.stage.canvas.canvas);
        } else {
          this.view_.insertBefore(this.audioShadePanel_, Entry.stage.canvas.canvas);
        }
      }
    }
  }, {
    key: "toggleAudioProgressPanel",
    value: function toggleAudioProgressPanel() {
      if (this.audioShadePanelOn) {
        Entry.engine.toggleAudioShadePanel();
      }
      if (this.audioProgressPanelOn) {
        this.audioProgressPanelOn = false;
        $(this.audioProgressPanel_).remove();
        delete this.audioProgressPanel_;
      } else if (Entry.engine.isState('run')) {
        var _fnDraw = function fnDraw() {
          audioProgressSpinner.width = audioProgressSpinner.width;
          fnCircle();
          window.requestAnimationFrame(_fnDraw);
        };
        var fnReturnDeg = function fnReturnDeg(deg) {
          return deg * Math.PI / 180;
        };
        var fnCircle = function fnCircle() {
          ctx.fillStyle = 'white';
          for (var i = 0; i < circlesRotate.length; i++) {
            ctx.beginPath();
            ctx.save();
            ctx.translate(audioProgressSpinner.width / 2, audioProgressSpinner.height / 2);
            ctx.rotate(fnReturnDeg(circlesRotate[i]));
            ctx.arc(0, -audioProgressSpinner.height / 3, 7, Math.PI, 10);
            ctx.fill();
            ctx.restore();
            if (circlesRotate[i] < 60 || circlesRotate[i] > 300) {
              circlesRotate[i] += 3;
            } else {
              circlesRotate[i] += 7;
            }
            if (circlesRotate[i] > 360) {
              circlesRotate[i] -= 360;
            }
          }
        };
        this.audioProgressPanelOn = true;
        this.audioProgressPanel_ = Entry.createElement('div', 'audioShadeCirclebox');
        this.audioProgressPanel_.addClass('audioShadeCirclebox');
        var audioShadeMainCircle = Entry.createElement('div', 'audioShadeCircle').addClass('audioShadeCircle');
        var audioProgressSpinner = Entry.createElement('canvas', 'audioProgressCanvas').addClass('audioProgress');
        var ctx = audioProgressSpinner.getContext('2d');
        var circlesRotate = [0, 15, 30, 45, 60];
        audioProgressSpinner.width = 100;
        audioProgressSpinner.height = 100;
        _fnDraw();
        audioShadeMainCircle.appendChild(audioProgressSpinner);
        this.audioProgressPanel_.appendChild(audioShadeMainCircle);
        var audioShadeText = Entry.createElement('div', 'audioShadeText').addClass('audioShadeText');
        audioShadeText.innerHTML = Lang.Msgs.ai_utilize_audio_progress;
        this.audioProgressPanel_.appendChild(audioShadeText);
        this.minimizedView_ = document.querySelector('#entryCanvasWrapper');
        if (this.view_.classList[0] === 'entryEngine') {
          this.minimizedView_.insertBefore(this.audioProgressPanel_, Entry.stage.canvas.canvas);
        } else {
          this.view_.insertBefore(this.audioProgressPanel_, Entry.stage.canvas.canvas);
        }
      }
    }
  }, {
    key: "hideAllAudioPanel",
    value: function hideAllAudioPanel() {
      if (this.audioShadePanelOn) {
        this.audioShadePanelOn = false;
        $(this.audioShadePanel_).remove();
        delete this.audioShadePanel_;
      }
      if (this.audioProgressPanelOn) {
        this.audioProgressPanelOn = false;
        $(this.audioProgressPanel_).remove();
        delete this.audioProgressPanel_;
      }
    }
  }, {
    key: "toggleSpeedPanel",
    value: function toggleSpeedPanel() {
      var _this3 = this;
      if (this.speedPanelOn) {
        this.speedPanelOn = false;
        this.speedButton.removeClass('on');
        $(this.speedLabel_).parent().remove();
        delete this.speedLabel_;
        $(this.speedProgress_).fadeOut(null, function (e) {
          $(this).remove();
          delete this.speedProgress_;
        });
        $(this.speedHandle_).remove();
        delete this.speedHandle_;
      } else {
        this.speedPanelOn = true;
        this.speedButton.addClass('on');
        var speedBox = Entry.createElement('div', 'entrySpeedBox');
        speedBox.addClass('entrySpeedBox');
        this.view_.insertBefore(speedBox, Entry.stage.canvas.canvas);
        this.speedLabel_ = Entry.createElement('div', 'entrySpeedLabelWorkspace');
        this.speedLabel_.textContent = Lang.Workspace.speed;
        speedBox.appendChild(this.speedLabel_);
        this.speedProgress_ = Entry.createElement('table', 'entrySpeedProgressWorkspace');
        var tr = Entry.createElement('tr').appendTo(this.speedProgress_);
        this.speeds.forEach(function (speed, i) {
          Entry.createElement('td', "progressCell".concat(i)).addClass('progressCell').bindOnClick(function () {
            _this3.setSpeedMeter(speed);
          }).appendTo(tr);
        });
        speedBox.appendChild(this.speedProgress_);
        this.setSpeedMeter(Entry.FPS);
      }
    }
  }, {
    key: "setSpeedMeter",
    value: function setSpeedMeter(FPS) {
      var level = this.speeds.indexOf(FPS);
      if (level < 0) {
        return;
      }
      level = Math.min(4, level);
      level = Math.max(0, level);
      if (this.speedPanelOn) {
        var elements = document.querySelectorAll(".progressCell");
        Array.from(elements).forEach(function (element, i) {
          if (level === i) {
            element.className = 'progressCell on';
          } else if (element.className.indexOf('on') > -1) {
            element.className = 'progressCell';
          }
        });
      }
      if (Entry.FPS == FPS) {
        return;
      }
      clearInterval(this.ticker);
      Entry.tickTime = Math.floor(1000 / FPS);
      this.ticker = setInterval(this.update, Entry.tickTime);
      Entry.FPS = FPS;
    }
  }, {
    key: "start",
    value: function start() {
      _GEHelper.GEHelper.Ticker.setFPS(Entry.FPS);
      if (!this.ticker) {
        Entry.tickTime = Math.floor(1000 / Entry.FPS);
        this.ticker = setInterval(this.update, Entry.tickTime);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      _GEHelper.GEHelper.Ticker.reset();
      _audioUtils["default"].stopRecord();
      clearInterval(this.ticker);
      this.ticker = null;
      this._stopEngineTimer();
      this._clearEngineTimeouts();
    }
  }, {
    key: "computeFunction",
    value:
    /**
     * Compute function for map. (Ntry 에 동일한 명칭의 함수가 있어 그대로 둠)
     */
    function computeFunction(_ref) {
      var script = _ref.script;
      script.tick();
    }

    /**
     * Check this state is same with argument
     * @param {string} state
     * @return {boolean}
     */
  }, {
    key: "isState",
    value: function isState(state) {
      return this.state.indexOf(state) > -1;
    }

    /**
     * Execute this function when click start button
     */
  }, {
    key: "run",
    value: function run() {
      if (this.isState('run')) {
        this.toggleStop();
      } else if (this.isState('stop') || this.isState('pause')) {
        this.toggleRun();
      }
    }

    /**
     * toggle this engine state run
     */
  }, {
    key: "toggleRun",
    value: function toggleRun(disableAchieve) {
      var isSupportWebAudio = window.AudioContext || window.webkitAudioContext;
      if (isSupportWebAudio && !this.isSoundInitialized) {
        createjs.WebAudioPlugin.playEmptySound();
        this.isSoundInitialized = true;
      }
      Entry.Utils.forceStopSounds();
      var variableContainer = Entry.variableContainer;
      var container = Entry.container;
      var WS = Entry.getMainWS();
      if (this.state === EntryEngineState.pause) {
        return this.togglePause();
      }
      Entry.Utils.blur();
      WS && WS.syncCode();
      Entry.addActivity('run');
      if (this.state === EntryEngineState.stop) {
        container.mapEntity(function (entity) {
          entity.takeSnapshot();
        });
        variableContainer.mapVariable(function (variable) {
          variable.takeSnapshot();
        });
        variableContainer.mapList(function (variable) {
          variable.takeSnapshot();
        });
        variableContainer.mapFunc(function (func) {
          func.takeSnapshot();
        });
        if (Entry.container.sttValue) {
          Entry.container.sttValue.takeSnapshot();
        }
        this.projectTimer.takeSnapshot();
        container.inputValue.takeSnapshot();
        container.takeSequenceSnapshot();
        Entry.scene.takeStartSceneSnapshot();
        this.state = EntryEngineState.run;
        this._resetEngineTimer();
        if (Entry.wasmEngine && Entry.wasmEngine.isAvailable()) {
          Entry.wasmEngine.start()["catch"](function (e) {
            console.error('[WasmEngine] Start failed:', e);
            Entry.engine.toggleStop();
          });
        } else {
          this.fireEvent('start');
        }
        this.achieveEnabled = !(disableAchieve === false);
      }
      this.state = EntryEngineState.run;
      if (Entry.type === 'mobile') {
        this.view_.addClass('entryEngineBlueWorkspace');
      }
      if (this.runButton) {
        this.setPauseButton(this.option);
        this.runButton.addClass('run');
        this.runButton.addClass('entryRemove');
        if (this.runButtonCurtain) {
          this.runButtonCurtain.addClass('entryRemove');
        }
        this.stopButton.removeClass('entryRemove');
        if (this.addButton) {
          this.addButton.addClass('entryRemove');
          if (Entry.objectAddable) {
            this.pauseButton.removeClass('entryRemove');
          }
        }
        if (this.pauseButton && (Entry.type === 'minimize' || Entry.objectAddable)) {
          this.pauseButton.removeClass('entryRemove');
        }
        if (this.runButton2) {
          this.runButton2.addClass('entryRemove');
        }
        if (this.stopButton2) {
          this.stopButton2.removeClass('entryRemove');
        }
        if (this.pauseButtonFull) {
          this.pauseButtonFull.removeClass('entryRemove');
        }
      }
      if (!this.isUpdating) {
        this.update();
        this.isUpdating = true;
      }
      this.setEnableInputField(true);
      this.selectedObject = Entry.stage.selectedObject;
      Entry.stage.selectObject();
      Entry.dispatchEvent('closeBackPack');
      Entry.dispatchEvent('run');
    }

    /**
     * toggle this engine state stop
     */
  }, {
    key: "toggleStop",
    value: (function () {
      var _toggleStop = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var container, variableContainer, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (Entry.wasmEngine && Entry.wasmEngine.isActive()) {
                Entry.wasmEngine.stop();
              }
              this.state = EntryEngineState.stopping;
              Entry.dispatchEvent('beforeStop');
              _context.prev = 1;
              _context.next = 2;
              return Promise.all(this.execPromises);
            case 2:
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
            case 4:
              container = Entry.container;
              variableContainer = Entry.variableContainer;
              Entry.Utils.blur();
              _audioUtils["default"].stopRecord();
              Entry.addActivity('stop');
              container.mapEntity(function (entity) {
                entity.loadSnapshot();
                entity.object.filters = [];
                entity.resetFilter();
                if (entity.dialog) {
                  entity.dialog.remove();
                }
                if (entity.brush) {
                  entity.removeBrush();
                }
                if (entity.paint) {
                  entity.removePaint();
                }
              });
              variableContainer.mapVariable(function (variable) {
                variable.loadSnapshot();
              });
              variableContainer.mapList(function (variable) {
                variable.loadSnapshot();
              });
              variableContainer.mapFunc(function (func) {
                func.loadSnapshot();
              });
              this.stopProjectTimer();
              if (Entry.timerInstances) {
                Entry.timerInstances.forEach(function (instance) {
                  instance.destroy();
                });
              }
              if (Entry.container.sttValue) {
                Entry.container.sttValue.loadSnapshot();
              }
              container.clearRunningState();
              container.loadSequenceSnapshot();
              this.projectTimer.loadSnapshot();
              container.inputValue.loadSnapshot();
              Entry.scene.loadStartSceneSnapshot();
              Entry.Func.clearThreads();
              Entry.Utils.setVolume(1);
              if (Entry.hwLite.getStatus() === 'connected') {
                Entry.hwLite.setZero();
              }
              createjs.Sound.setVolume(1);
              createjs.Sound.stop();
              Entry.soundInstances.clear();
              Entry.bgmInstances.clear();
              Entry.playbackRateValue = 1;
              Entry.targetChecker && Entry.targetChecker.clearListener();
              this.view_.removeClass('entryEngineBlueWorkspace');
              if (this.runButton) {
                this.runButton.removeClass('entryRemove');
                if (this.runButtonCurtain) {
                  this.runButtonCurtain.removeClass('entryRemove');
                }
                this.stopButton.addClass('entryRemove');
                if (this.pauseButton) {
                  this.pauseButton.addClass('entryRemove');
                }
                if (this.pauseButtonFull) {
                  this.pauseButtonFull.addClass('entryRemove');
                }
                if (this.addButton && Entry.objectAddable) {
                  this.addButton.removeClass('entryRemove');
                }
                if (this.runButton2) {
                  this.runButton2.removeClass('entryRemove');
                }
                if (this.stopButton2) {
                  this.stopButton2.addClass('entryRemove');
                }
              }
              this.state = EntryEngineState.stop;
              this._stopEngineTimer();
              this._clearEngineTimeouts();
              this.setEnableInputField(false);
              Entry.dispatchEvent('stop');
              Entry.stage.hideInputField();
              (function (w) {
                w && w.getMode() === Entry.Workspace.MODE_VIMBOARD && w.codeToText();
              })(Entry.getMainWS());
              Entry.dispatchEvent('dispatchEventDidToggleStop');
              Entry.stage.selectObject(this.selectedObject);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3]]);
      }));
      function toggleStop() {
        return _toggleStop.apply(this, arguments);
      }
      return toggleStop;
    }())
  }, {
    key: "setEnableInputField",
    value: function setEnableInputField(on) {
      var inputField = Entry.stage.inputField;
      if (inputField) {
        inputField._readonly = !on;
        if (!inputField._isHidden) {
          on ? inputField.focus() : inputField.blur();
        }
      }
    }

    /**
     * toggle this engine state pause
     */
  }, {
    key: "togglePause",
    value: function togglePause() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$visible = _ref2.visible,
        visible = _ref2$visible === void 0 ? true : _ref2$visible;
      if (Entry.wasmEngine && Entry.wasmEngine.isActive()) {
        if (this.state === EntryEngineState.pause) {
          Entry.wasmEngine.resume();
          this.state = EntryEngineState.run;
          if (visible && this.runButton) {
            this.setPauseButton(this.option);
            if (this.runButton2) {
              this.runButton2.addClass('entryRemove');
            } else {
              this.runButton.addClass('entryRemove');
              if (this.runButtonCurtain) {
                this.runButtonCurtain.addClass('entryRemove');
              }
            }
          }
        } else {
          Entry.wasmEngine.pause();
          this.state = EntryEngineState.pause;
          if (visible && this.runButton) {
            this.setPauseButton(this.option);
            this.stopButton.removeClass('entryRemove');
            if (this.runButton2) {
              this.runButton2.removeClass('entryRemove');
            } else {
              this.runButton.removeClass('entryRemove');
              if (this.runButtonCurtain) {
                this.runButtonCurtain.removeClass('entryRemove');
              }
            }
          }
        }
        Entry.dispatchEvent('dispatchEventDidTogglePause');
        return;
      }
      var timer = Entry.engine.projectTimer;
      if (this.state === EntryEngineState.pause) {
        this.setEnableInputField(true);
        timer.pausedTime += new Date().getTime() - timer.pauseStart;
        if (timer.isPaused) {
          timer.pauseStart = new Date().getTime();
        } else {
          delete timer.pauseStart;
        }
        this.state = EntryEngineState.run;
        this._resumeEngineTimer();
        Entry.Utils.recoverSoundInstances();
        if (visible && this.runButton) {
          this.setPauseButton(this.option);
          if (this.runButton2) {
            this.runButton2.addClass('entryRemove');
          } else {
            this.runButton.addClass('entryRemove');
            if (this.runButtonCurtain) {
              this.runButtonCurtain.addClass('entryRemove');
            }
          }
        }
        if (Entry.timerInstances) {
          Entry.timerInstances.forEach(function (instance) {
            instance.resume();
          });
        }
      } else {
        this.state = EntryEngineState.pause;
        this.setEnableInputField(false);
        if (!timer.isPaused) {
          timer.pauseStart = new Date().getTime();
        } else {
          timer.pausedTime += new Date().getTime() - timer.pauseStart;
          timer.pauseStart = new Date().getTime();
        }
        this._pauseEngineTimer();
        Entry.Utils.pauseSoundInstances();
        if (visible && this.runButton) {
          this.setPauseButton(this.option);
          this.stopButton.removeClass('entryRemove');
          if (this.runButton2) {
            this.runButton2.removeClass('entryRemove');
          } else {
            this.runButton.removeClass('entryRemove');
            if (this.runButtonCurtain) {
              this.runButtonCurtain.removeClass('entryRemove');
            }
          }
        }
        if (Entry.timerInstances) {
          Entry.timerInstances.forEach(function (instance) {
            instance.pause();
          });
        }
      }
      Entry.dispatchEvent('dispatchEventDidTogglePause');
    }
  }, {
    key: "setPauseButton",
    value: function setPauseButton() {
      if (this.state === EntryEngineState.pause) {
        if (this.pauseButton) {
          this.pauseButton.textContent = Lang.Workspace.restart;
          if (this.option !== 'minimize') {
            this.pauseButton.removeClass('entryPauseButtonWorkspace_w');
            this.pauseButton.addClass('entryRestartButtonWorkspace_w');
          }
        }
        if (this.pauseButtonFull) {
          this.pauseButtonFull.textContent = Lang.Workspace.restart;
          if (this.option !== 'minimize') {
            // workspace && buttonWrapper check
            if (this.buttonWrapper) {
              this.pauseButtonFull.addClass('entryPauseButtonWorkspace_full');
            } else {
              this.pauseButtonFull.removeClass('entryPauseButtonWorkspace_full');
            }
            this.pauseButtonFull.addClass('entryRestartButtonWorkspace_full');
          }
        }
      } else {
        if (this.pauseButton) {
          this.pauseButton.textContent = Lang.Workspace.pause;
          if (this.option !== 'minimize') {
            this.pauseButton.addClass('entryPauseButtonWorkspace_w');
            this.pauseButton.removeClass('entryRestartButtonWorkspace_w');
          }
        }
        if (this.pauseButtonFull) {
          this.pauseButtonFull.textContent = Lang.Workspace.pause;
          if (this.option !== 'minimize') {
            this.pauseButtonFull.addClass('entryPauseButtonWorkspace_full');
            this.pauseButtonFull.removeClass('entryRestartButtonWorkspace_full');
          }
        }
      }
    }

    /**
     * @param {string} eventName
     */
  }, {
    key: "fireEvent",
    value: function fireEvent(eventName) {
      if (this.state !== EntryEngineState.run) {
        return;
      }
      Entry.container.mapEntityIncludeCloneOnScene(this.raiseEvent, eventName);
    }

    /**
     * @param {string} eventName
     * @param {string} value
     */
  }, {
    key: "fireEventWithValue",
    value: function fireEventWithValue(eventName, value) {
      if (this.state !== EntryEngineState.run) {
        return;
      }
      return Entry.container.mapEntityIncludeCloneOnScene(this.raiseKeyEvent, [eventName, value]);
    }
  }, {
    key: "fireEventOnEntity",
    value:
    /**
     * @param {string} eventName
     * @param {Entry.EntityObject} entity
     */
    function fireEventOnEntity(eventName, entity) {
      if (this.state === EntryEngineState.run) {
        Entry.container.mapEntityIncludeCloneOnScene(this.raiseEventOnEntity, [entity, eventName]);
      }
    }

    /**
     * this is callback function for map.
     * @param {Entry.EntryObject} object
     * @param {Array} param
     */
  }, {
    key: "raiseEventOnEntity",
    value: function raiseEventOnEntity(entity, param) {
      if (entity !== param[0]) {
        return;
      }
      var eventName = param[1];
      entity.parent.script.raiseEvent(eventName, entity);
    }

    /**
     * @param {KeyboardEvent} e
     * @param {boolean} isForce
     */
  }, {
    key: "captureKeyEvent",
    value: function captureKeyEvent(e, isForce) {
      var keyCode = Entry.Utils.inputToKeycode(e);
      if (!keyCode) {
        return;
      }
      var isWorkspace = Entry.type === 'workspace';
      if (Entry.Utils.isInInput(e) && !isForce) {
        return;
      }

      //mouse shortcuts
      if (keyCode !== 17 && e.ctrlKey && isWorkspace) {
        if (keyCode === 83) {
          e.preventDefault();
          Entry.dispatchEvent(e.shiftKey ? 'saveAsWorkspace' : 'saveWorkspace');
        } else if (keyCode === 82) {
          e.preventDefault();
          Entry.engine.run();
        } else if (keyCode === 90) {
          e.preventDefault();
          Entry.dispatchEvent(e.shiftKey ? 'redo' : 'undo');
        }
      } else if (Entry.engine.isState('run')) {
        e.preventDefault && e.preventDefault();
        Entry.container.mapEntityIncludeCloneOnScene(Entry.engine.raiseKeyEvent, ['keyPress', keyCode]);
      }
      if (Entry.engine.isState('stop')) {
        if (isWorkspace && keyCode >= 37 && keyCode <= 40) {
          Entry.stage.moveSprite(e);
        }
      }
    }
  }, {
    key: "raiseKeyEvent",
    value: function raiseKeyEvent(entity, _ref3) {
      var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
        eventName = _ref4[0],
        keyCode = _ref4[1];
      return entity.parent.script.raiseEvent(eventName, entity, String(keyCode));
    }
  }, {
    key: "updateMouseView",
    value: function updateMouseView() {
      var _Entry$stage$mouseCoo = Entry.stage.mouseCoordinate,
        x = _Entry$stage$mouseCoo.x,
        y = _Entry$stage$mouseCoo.y;
      this.mouseViewInput.value = "X : ".concat(x, ", Y : ").concat(y);
      this.mouseView.removeClass('entryHide');
    }
  }, {
    key: "hideMouseView",
    value: function hideMouseView() {
      this.mouseView.addClass('entryHide');
    }
  }, {
    key: "toggleFullScreen",
    value: function toggleFullScreen(popupClassName) {
      Entry.dispatchEvent('toggleFullScreen');
      if (!Entry.fullScreenEnable) {
        return;
      }
      if (!this.popup) {
        Entry.view_.addClass('fullscreen');
        this.popup = new Entry.Popup(popupClassName);
        if (Entry.engine.speedPanelOn) {
          Entry.engine.toggleSpeedPanel();
        }
        if (Entry.type !== 'workspace') {
          var $doc = $(document);
          var body = $(this.popup.body_);
          body.css('top', $doc.scrollTop());
          $('body').css('overflow', 'hidden');
          popup.window_.appendChild(Entry.stage.canvas.canvas);
          popup.window_.appendChild(Entry.engine.runButton[0]);
        }
        popup.window_.appendChild(Entry.engine.view_);
        if (Entry.type === 'workspace') {
          Entry.engine.view_.appendChild(this.buttonWrapper);
          if (Entry.targetChecker) {
            popup.window_.appendChild(Entry.targetChecker.getStatusView()[0]);
          }
        }
        if (window.top !== window.self) {
          if (Entry.iframeDomAccess === 'direct') {
            window.top.addEventListener('pointermove', this.copyEvent);
            window.top.addEventListener('pointerdown', this.copyEvent);
            window.top.addEventListener('pointerup', this.copyEvent);
            window.top.addEventListener('pointerupoutside', this.copyEvent);
            window.top.addEventListener('pointercancel', this.copyEvent);
            window.top.addEventListener('mouseup', this.copyEvent);
            window.top.addEventListener('mousemove', this.copyEvent);
          } else if (Entry.iframeDomAccess === 'message') {
            window.top.postMessage({
              type: 'toggleFullScreen',
              value: 'addEvent'
            }, '*');
          }
        }
      } else {
        if (window.top !== window.self) {
          if (Entry.iframeDomAccess === 'direct') {
            window.top.removeEventListener('pointermove', this.copyEvent);
            window.top.removeEventListener('pointerdown', this.copyEvent);
            window.top.removeEventListener('pointerup', this.copyEvent);
            window.top.removeEventListener('pointerupoutside', this.copyEvent);
            window.top.removeEventListener('pointercancel', this.copyEvent);
            window.top.removeEventListener('mouseup', this.copyEvent);
            window.top.removeEventListener('mousemove', this.copyEvent);
          } else if (Entry.iframeDomAccess === 'message') {
            window.top.postMessage({
              type: 'toggleFullScreen',
              value: 'removeEvent'
            }, '*');
          }
        }
        this.popup.remove();
        this.popup = null;
      }
      Entry.windowResized.notify();
    }
  }, {
    key: "copyEvent",
    value: function copyEvent(event) {
      var eventClone = new event.constructor(event.type, event);
      window.self.dispatchEvent(eventClone);
      if (_GEHelper.GEHelper.isWebGL && ['mousemove', 'pointermove'].includes(event.type)) {
        window.document.dispatchEvent(eventClone);
      }
    }
  }, {
    key: "closeFullScreen",
    value: function closeFullScreen() {
      if (this.popup) {
        this.popup.remove();
        this.popup = null;
      }
      Entry.windowResized.notify();
    }
  }, {
    key: "exitFullScreen",
    value: function exitFullScreen() {
      if (document.webkitIsFullScreen || document.mozIsFullScreen || document.isFullScreen) {} else {
        Entry.engine.footerView_.removeClass('entryRemove');
        Entry.engine.headerView_.removeClass('entryRemove');
      }
      Entry.windowResized.notify();
    }
  }, {
    key: "showProjectTimer",
    value: function showProjectTimer() {
      var timer = Entry.engine.projectTimer;
      if (!timer) {
        return;
      }
      this.projectTimer.setVisible(true);
    }
  }, {
    key: "hideProjectTimer",
    value: function hideProjectTimer(removeBlock, notIncludeSelf) {
      var timer = this.projectTimer;
      if (!timer || !timer.isVisible() || this.isState('run')) {
        return;
      }
      var objects = Entry.container.getAllObjects();
      var timerTypes = ['get_project_timer_value', 'reset_project_timer', 'set_visible_project_timer', 'choose_project_timer_action'];
      for (var i = 0, len = objects.length; i < len; i++) {
        var code = objects[i].script;
        for (var j = 0; j < timerTypes.length; j++) {
          var blocks = code.getBlockList(false, timerTypes[j]);
          if (notIncludeSelf) {
            var index = blocks.indexOf(removeBlock);
            if (index > -1) {
              blocks.splice(index, 1);
            }
          }
          if (blocks.length > 0) {
            return;
          }
        }
      }
      timer.setVisible(false);
    }
  }, {
    key: "clearTimer",
    value: function clearTimer() {
      clearInterval(this.ticker);
      clearInterval(this.projectTimer.tick);
    }
  }, {
    key: "startProjectTimer",
    value: function startProjectTimer() {
      var timer = this.projectTimer;
      if (!timer) {
        return;
      }
      timer.start = new Date().getTime();
      timer.isInit = true;
      timer.isPaused = false;
      timer.pausedTime = 0;
      timer.tick = setInterval(function (e) {
        Entry.engine.updateProjectTimer();
      }, 1000 / 60);
    }
  }, {
    key: "stopProjectTimer",
    value: function stopProjectTimer() {
      var timer = this.projectTimer;
      if (!timer) {
        return;
      }
      this.updateProjectTimer(0);
      timer.isPaused = false;
      timer.isInit = false;
      timer.pausedTime = 0;
      clearInterval(timer.tick);
    }
  }, {
    key: "resetTimer",
    value: function resetTimer() {
      var timer = this.projectTimer;
      if (!timer.isInit) {
        return;
      }
      var isPaused = timer.isPaused;
      delete timer.pauseStart;
      this.updateProjectTimer(0);
      timer.pausedTime = 0;
      timer.isPaused = isPaused;
      if (!isPaused) {
        return;
      }
      clearInterval(timer.tick);
      timer.isInit = false;
      delete timer.start;
    }
  }, {
    key: "updateProjectTimer",
    value: function updateProjectTimer(value) {
      var engine = Entry.engine;
      var timer = engine.projectTimer;
      if (!timer) {
        return;
      }
      var current = new Date().getTime();
      if (typeof value == 'undefined') {
        if (!timer.isPaused && !engine.isState('pause')) {
          timer.setValue(Math.max((current - (timer.start || current) - timer.pausedTime) / 1000, 0));
        }
      } else {
        timer.setValue(value);
        timer.pausedTime = 0;
        timer.start = current;
      }
    }
  }, {
    key: "raiseMessage",
    value: function raiseMessage(value) {
      Entry.message.notify(Entry.variableContainer.getMessage(value));
      return Entry.container.mapEntityIncludeCloneOnScene(this.raiseKeyEvent, ['when_message_cast', value]);
    }
  }, {
    key: "getDom",
    value: function getDom(query) {
      if (query.length >= 1) {
        switch (query.shift()) {
          case 'runButton':
            return this.runButton;
          case 'stopButton':
            return this.stopButton;
          case 'objectAddButton':
            return this.addButton;
        }
      } else {}
    }
  }, {
    key: "attachKeyboardCapture",
    value: function attachKeyboardCapture() {
      if (Entry.keyPressed) {
        this._keyboardEvent && this.detachKeyboardCapture();
        this._keyboardEvent = Entry.keyPressed.attach(this, this.captureKeyEvent);
      }
    }
  }, {
    key: "detachKeyboardCapture",
    value: function detachKeyboardCapture() {
      if (Entry.keyPressed && this._keyboardEvent) {
        this._keyboardEvent.destroy();
        delete this._keyboardEvent;
      }
    }
  }, {
    key: "applyOption",
    value: function applyOption() {
      var SMALL = 'small';
      if (Entry.objectAddable) {
        this.runButton.addClass(SMALL);
        this.stopButton.addClass(SMALL);
        this.addButton.removeClass('entryRemove');
      } else {
        this.runButton.removeClass(SMALL);
        this.stopButton.removeClass(SMALL);
        this.addButton.addClass('entryRemove');
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      // 우선 interface 만 정의함.
    }
  }, {
    key: "trimPromiseExecutor",
    value: function trimPromiseExecutor() {
      return this.execPromises.filter(function (promise) {
        return promise instanceof Promise;
      });
    }
  }, {
    key: "addPromiseExecutor",
    value: function addPromiseExecutor(promises) {
      var _this4 = this;
      this.execPromises = this.trimPromiseExecutor();
      var index = this.execPromises.length;
      promises.forEach(function (promise, i) {
        var execPromise = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
          var result, j;
          return _regenerator["default"].wrap(function (_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 1;
                return promise;
              case 1:
                result = _context2.sent;
                j = Entry.engine.execPromises.indexOf(execPromise);
                Entry.engine.execPromises[j] = result;
              case 2:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }))();
        _this4.execPromises[index + i] = execPromise;
      });
    }
  }, {
    key: "_resetEngineTimer",
    value: function _resetEngineTimer() {
      var timer = this.engineTimer;
      timer.start = new Date().getTime();
      timer.pausedTime = 0;
      timer.pauseStart = 0;
      timer.isPaused = false;
      timer.isInit = true;
    }
  }, {
    key: "_pauseEngineTimer",
    value: function _pauseEngineTimer() {
      var timer = this.engineTimer;
      if (!timer.isInit || timer.isPaused) {
        return;
      }
      timer.isPaused = true;
      timer.pauseStart = new Date().getTime();
    }
  }, {
    key: "_resumeEngineTimer",
    value: function _resumeEngineTimer() {
      var timer = this.engineTimer;
      if (!timer.isInit || !timer.isPaused) {
        return;
      }
      if (timer.pauseStart) {
        timer.pausedTime += new Date().getTime() - timer.pauseStart;
      }
      timer.pauseStart = 0;
      timer.isPaused = false;
    }
  }, {
    key: "_stopEngineTimer",
    value: function _stopEngineTimer() {
      var timer = this.engineTimer;
      timer.isInit = false;
      timer.isPaused = false;
      timer.start = 0;
      timer.pauseStart = 0;
      timer.pausedTime = 0;
    }
  }, {
    key: "_getEngineTimeMs",
    value: function _getEngineTimeMs() {
      var timer = this.engineTimer;
      if (!timer.isInit) {
        return 0;
      }
      var now = timer.isPaused && timer.pauseStart ? timer.pauseStart : new Date().getTime();
      return Math.max(now - timer.start - timer.pausedTime, 0);
    }
  }, {
    key: "_processEngineTimeouts",
    value: function _processEngineTimeouts() {
      if (!this._engineTimeouts.length) {
        return;
      }
      var nowMs = this._getEngineTimeMs();
      var timeouts = this._engineTimeouts;
      var writeIndex = 0;
      for (var i = 0; i < timeouts.length; i++) {
        var item = timeouts[i];
        if (item.targetTimeMs <= nowMs) {
          try {
            item.callback();
          } catch (e) {
            console.error('Engine setTimeout callback error', e);
          }
        } else {
          timeouts[writeIndex++] = item;
        }
      }
      if (writeIndex !== timeouts.length) {
        timeouts.length = writeIndex;
      }
    }
  }, {
    key: "_clearEngineTimeouts",
    value: function _clearEngineTimeouts() {
      this._engineTimeouts = [];
    }
  }, {
    key: "setTimeout",
    value: function setTimeout(callback, delay) {
      if (typeof callback !== 'function') {
        return null;
      }
      var id = ++this._engineTimeoutSeq;
      var targetTimeMs = this._getEngineTimeMs() + Math.max(Number(delay) || 0, 0);
      this._engineTimeouts.push({
        id: id,
        callback: callback,
        targetTimeMs: targetTimeMs
      });
      return id;
    }
  }, {
    key: "clearTimeout",
    value: function clearTimeout(id) {
      this._engineTimeouts = this._engineTimeouts.filter(function (item) {
        return item.id !== id;
      });
    }
  }]);
}();